import { Check } from 'lucide-react'

const Item = ({ option, isSelected, onSelect }) => {
  let { title, description, icon: Icon, colorClass } = option

  return (
    <div
      onClick={onSelect}
      className={`flex items-start gap-4 p-4 mb-3 rounded-xl border-2 transition-all duration-200 cursor-pointer select-none ${isSelected
        ? 'border-blue-500 bg-blue-50/10'
        : 'border-secondary-200 bg-white hover:border-secondary-300'
        }`}
    >
      <div className={`p-2 rounded-xl mt-0.5 ${colorClass}`}>
        <Icon size={16} />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between">
          <h4 className="text-xs font-bold text-secondary-950">{title}</h4>
          <div
            className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-blue-500 bg-blue-500 text-white' : 'border-secondary-300'
              }`}
          >
            {isSelected && <Check size={10} className="stroke-[3]" />}
          </div>
        </div>
        <p className="text-[11px] text-secondary-500 mt-1 leading-relaxed">{description}</p>

        {isSelected && option.input && (
          <input
            type={'email'}
            placeholder={'Enter your email'}
            value={option.input.value || ''}
            onChange={(e) => option.input.onChange?.(e.target.value)}
            onClick={(e) => e.stopPropagation()}
            className="w-full mt-3 px-3 py-2 text-xs border border-secondary-200 rounded-lg outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all"
          />
        )}
      </div>
    </div>
  )
}

export default Item
